"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-circle-track.tsx
var ProgressCircleTrack = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getCircleTrackProps(), props);
	return /* @__PURE__ */ jsx(ark.circle, {
		ref,
		...mergedProps
	});
});
ProgressCircleTrack.displayName = "ProgressCircleTrack";
//#endregion
export { ProgressCircleTrack };
